import { type Demo } from '@/types';
import { makeActionCreator, makeRequestActionCreator } from '@/utils';
import { demoSlice } from './slice';

const createAction = makeActionCreator(demoSlice.name);
const createRequestAction = makeRequestActionCreator(demoSlice.name);

export const tryFetchDemo = createRequestAction<void, Demo>('tryFetchDemo');
export const fetchDemo = createRequestAction<void, Demo>('fetchDemo');
export const refetchDemo = createAction('refetchDemo');
export const acceptModal = createAction<{ id: string }>('acceptModal');
export const cancelModal = createAction<{ id: string }>('cancelModal');

export const { setDemo } = demoSlice.actions;
